import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { DebugUpdateBusPositonRequest } from "./DebugUpdateBusPositonRequest";
import { DebugUpdateStudentPositonRequest } from "./DebugUpdateStudentPositonRequest";
import { DebugCreateBusRequest } from "./DebugCreateBusRequest";
import { DebugCreateStudentRequest } from "./DebugCreateStudentRequest";

@Injectable()
export class DataService_BusTrackerDebug {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	DebugUpdateBusPosition(parms: DebugUpdateBusPositonRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/DebugUpdateBusPosition";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DebugUpdateStudentPosition(parms: DebugUpdateStudentPositonRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/DebugUpdateStudentPosition";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DebugCreateBusBusSelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/DebugCreateBusBusSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DebugCreateBusRouteSelectList(BusID) {
		var postResult$ = new Subject();
		var url = "BusTracker/DebugCreateBusRouteSelectList?BusID=" + BusID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DebugCreateBusDriverSelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/DebugCreateBusDriverSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DebugCreateBus(parms: DebugCreateBusRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/DebugCreateBus";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DebugCreateStudentEntrySelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/DebugCreateStudentEntrySelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DebugCreateStudentStudentSelectList(EntryTypeID, BusRouteID) {
		var postResult$ = new Subject();
		var url = "BusTracker/DebugCreateStudentStudentSelectList?EntryTypeID=" + EntryTypeID + "&BusRouteID=" + BusRouteID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DebugCreateStudentBusSelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/DebugCreateStudentBusSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DebugCreateStudent(parms: DebugCreateStudentRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/DebugCreateStudent";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DebugDeleteBus(BusID) {
		var postResult$ = new Subject();
		var url = "BusTracker/DebugDeleteBus?BusID=" + BusID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DebugDeleteStudent(BusStudentRideTxnID) {
		var postResult$ = new Subject();
		var url = "BusTracker/DebugDeleteStudent?BusStudentRideTxnID=" + BusStudentRideTxnID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
